import { Component, ElementRef, Input, OnInit, Output, Renderer2, ViewChild, ChangeDetectorRef, AfterViewInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { EventEmitter } from '@angular/core';
import { DhlFormControl } from '../../models/dhl-form-control';
import { Observable, Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { CommonConfig } from 'src/app/common/configuration/common.config';
import { APP_Constants } from 'src/app/app.constant';
import { AlphaService } from 'src/app/app-business-object-module/alpha.service'
import { Modal } from 'src/app/common/modal/modal';
import { ModalService } from 'src/app/common/modal/modal.service';
import { AppService } from 'src/app/app.service';
import { ErrorsConfig } from 'src/app/common/configuration/errors.config';
import { DhlFormControlAutocomplete } from '../../models/dhl-form-control-autocomplete';
import { DhlFormControlEvent } from '../../models/dhl-form-control-event';
import { DhlFormControlEventData } from '../../models/dhl-form-control-event-data';
import {TranslateService} from '@ngx-translate/core';
import { DomEventService } from 'src/app/common/dom-event/dom-event.service';
import  {Constant}  from '../../../constants/constants';

@Component({
    selector: 'app-form-field-generic-autocomplete-v2',
    templateUrl: './form-field-generic-autocomplete-v2.component.html',
    styleUrls: ['./form-field-generic-autocomplete-v2.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class FormFieldGenericAutocompleteV2Component implements OnInit, AfterViewInit, OnDestroy {

  @Input() configData: DhlFormControl;
  @Input() frmGroup: UntypedFormGroup;

  @Input() fieldMetadata;
  @Output() fieldAction = new EventEmitter();
  @Output() controlValue = new EventEmitter();

  @ViewChild('formControl', {static: true, read: ElementRef}) formControl: ElementRef;
  @ViewChild('inputEle', {static: true, read: ElementRef}) inputEle: ElementRef;

  placeholder: string = '';
  validationType: string = '';
  fieldType: string = '';
  fieldIcon: string = '';

  pickerToggle: boolean = false;
  validators = Validators;

  // seach-com code
  public suggestionList: any[];
  private searchTerms = new Subject<any>();
  suggestion: boolean;
  public selectedItems: Array<any>;
  typing = false;
  searchStr = "";
  selection: string;
  noItemFound: boolean = false;
  noItemFoundError; selectFromListError;
  // make api call vars
  progressBar = false;
  color: String = 'primary';
  mode: String = 'indeterminate';
  autoCompleteMetaData: DhlFormControlAutocomplete;
  excludeItem: string = '';
  addNewSuggestion = false;
  isOpenManualAddSuggestion = false;
  clickEventSubscription: Subscription;
  keyUpEventSubscription: Subscription;
  keyUpTabEventSubscription: Subscription;
  enum=Constant;
  controlUrlFlag: boolean = false;
  controlStateSubscription: Subscription;
  isRequiredControl: boolean = false;
  // enum=Constant;
  disableSwitch :boolean = false;
  isResetting: boolean = false;
  previousFormFieldData;
  dynamicDataAdded:any = false;
  editField: boolean;
  isLoading: boolean;
  templateData: any;
  selfServiceConfig: boolean = false;
  constructor(private cd: ChangeDetectorRef, private _eref: ElementRef, private renderer: Renderer2, private modalService: ModalService, private appService: AppService, private domEventService: DomEventService
       , private translate: TranslateService,private alphaService : AlphaService) {
    this.suggestionList = [];
    this.suggestion = true;
  }

  ngOnInit() {
    if(this.configData.customFormFlag){
      this.selfServiceConfig = false;
    }
    else if(sessionStorage.getItem('isSelfServiceConfig'))
    {
      this.selfServiceConfig = true;
    }
    this.frmGroup.get(this.configData.name)['itemArray'] = [];
    this.searchStr = this.frmGroup.get(this.configData.name)?.value?.value ?? this.frmGroup.get(this.configData.name)?.value;
    if(this.frmGroup.get(this.configData.name).value){
      this.frmGroup.get(this.configData.name)['itemArray'].push(this.frmGroup.get(this.configData.name).value);
    }
    this.autoCompleteMetaData = new DhlFormControlAutocomplete(this.configData);
    this.fieldType = this.fieldMetadata ? this.fieldMetadata.fieldType : 'search';
    this.fieldIcon = this.fieldMetadata ? this.fieldMetadata.fieldIcon : null;
    this.toggleDisable(this.configData['disabled']);
    if (this.configData.validation.length)
      this.fieldValueValidation(this.configData.validation);

    this.searchTerms.pipe(debounceTime(CommonConfig.ITEM_SEARCH_TIMEOUT))
      .subscribe(term => {
        if(!this.isOpenManualAddSuggestion)
        this.makeapicall(term);
        this.dynamicDataAdded= false;
      });
    this.noItemFound = false;
    // WHY THIS PIECE OF CODE?
    //If 'itemArray' is not empty then we are saving value as default value into 'itemArray' for RESET.
    if(Array.isArray(this.frmGroup.get(this.configData.name)['itemArray']) && this.frmGroup.get(this.configData.name)['itemArray'].length > 0){
      // this.configData.defaultValue = this.frmGroup.get(this.configData.name)['itemArray'];
    }
    // this.frmGroup.get(this.configData.name)['itemArray'] = [];
    if(this.configData["secondaryText"]?.length > 0) this.frmGroup['secondaryText'] = '';
    if(this.configData["primaryText"]?.length > 0) this.frmGroup['primaryText'] = '';
    this.noItemFoundError = ErrorsConfig.autocomplete.notFound;
    this.selectFromListError = ErrorsConfig.autocomplete.selectFromList;
    //if (localStorage.getItem('templateName') === 'orderViewEdit' || localStorage.getItem('templateName') === "releaseOrderViewEdit") {
      //this.frmGroup.get(this.configData.name)['itemArray'].push(this.frmGroup.get(this.configData.name).value);
    //}
    this.clickEventSubscription = this.domEventService.click.subscribe((e: MouseEvent) => this.onWindowClick(e));
    this.keyUpEventSubscription = this.domEventService.keyUp.subscribe((e: KeyboardEvent) => this.onWindowClick(e));
    this.keyUpTabEventSubscription = this.domEventService.keyUpTab.subscribe((e: KeyboardEvent) => this.onWindowClick(e));
    if (this.configData['dynamicVisibility']) {
      if (this.configData['dynamicVisibility'].action == 'hidden') {
        this.frmGroup.get(this.configData.name)['hidden'] = !this.checkAccess(this.configData['dynamicVisibility'].featureName);
      } else if (this.configData['dynamicVisibility'].action == 'disabled') {
        if (this.checkAccess(this.configData['dynamicVisibility'].featureName) == false) {
          this.toggleDisable(true);
        }
      }
    }

    //CP-9064 start
    if (this.configData['editAccess']) {
      this.configData['editAccess'].forEach(row => {
        let persona;
        if(row.roleAccess){
          persona = row.roleAccess;
        } else {
          persona = row.persona;
        }
        if(row.action == 'disabled'){
          if(this.checkFieldAccess(persona) == false){
            this.configData['disabled'] = true;
            this.frmGroup.get(this.configData.name).disable();
          }
        }
      });
    }
    //CP-9064 end
    
    //this.checkFormStatusListen();
    this.storePreviousValue();
    this.alphaService.checkEditAccess(this.configData, this.frmGroup);

    this.frmGroup.get(this.configData.name)?.valueChanges.subscribe((value) => {
      const isDisabled = this.frmGroup.get(this.configData.name)?.disabled;
      if (value && isDisabled) {
        this.alphaService.manageAffectedColumn(this.configData, this.frmGroup, { primaryValue: value.trim() });
        this.frmGroup.get(this.configData.name)['dynamicDataAdded'] = true;
      }
    });
  }

  checkAccess(access) {
    let menuPages = localStorage.getItem('menuPages');
    return menuPages.includes(access);
  }
  checkFieldAccess(persona) {
    let role = localStorage.getItem('userRole');
    return persona.includes(role);
  }
  ngAfterViewInit() {
    this.placeholder = this.configData.placeHolder;
    let form = this.frmGroup.get(this.configData.name)
    this.configData.validation.forEach(element => {
      if (element === 'hidden' && form['hidden']) {
        setTimeout(function () {
          form.setValidators(null);
          form.updateValueAndValidity();
        }, 100);
      }
    });

    if (form && form.value) {
      if (this.configData && this.configData.events && Array.isArray(this.configData.events) && this.configData.events.length > 0 && this.configData.events.find(e => e.event === "VALIDATE_WHEN_AUTOCOMPLETE_SELECTED")) {
        setTimeout(() => {
          this.selectItem(null, { primaryText: form.value, primaryValue: form.value }, false, true);
        }, 1000);
      }
      if(this.configData?.affectedColumns?.length > 0){
        this.selectItem(null, { primaryText: form.value, primaryValue: form.value }, false, true);
      }
      this.frmGroup.get(this.configData.name).updateValueAndValidity();
    }
    this.storePreviousValue();

    let filterObj = this.alphaService.getFilteredObject("setFiltersValues");
    if (filterObj?.[this.configData.name]) {
      let selectedOption = filterObj[this.configData.name];
      this.frmGroup.get(this.configData.name).setValue(selectedOption);
    }
  }

  ngAfterViewChecked() {
    let frmGroup = this.frmGroup?.get(this.configData?.name);
    if (frmGroup['required'] === false && frmGroup?.errors?.required !== true) {
      this.configData.required = false;
    }
  }

  toggleVisibility(hidden = !this.frmGroup.get(this.configData.name)['hidden']){
    this.configData.required = hidden ? !hidden : this.configData.required;
    this.frmGroup.get(this.configData.name)['hidden'] = hidden;
    if(hidden){
      this.frmGroup.get(this.configData.name).reset();
      this.frmGroup.get(this.configData.name).setErrors(null);  // to remove required validation from form in case of hidden                  
      this.frmGroup.get(this.configData.name).clearValidators();
      this.frmGroup.get(this.configData.name).updateValueAndValidity();
    } else {
      // Set validation if field is not hidden and field is required
      if(this.configData.required){
        this.frmGroup.get(this.configData.name).setValidators([Validators.required]);
        this.frmGroup.get(this.configData.name).updateValueAndValidity();   
      }
    }
  }

  fieldValueValidation(validations) {
    validations.forEach((validataion: string | any) => {
      let element = (typeof validataion == "object" ? validataion.name : validataion);
      if (element === 'hidden') {
        if (!(this.frmGroup.get(this.configData.name)['hidden'] === false)) {
          this.frmGroup.get(this.configData.name)['hidden'] = true;
          this.configData.required = false;
          this.frmGroup.get(this.configData.name).clearValidators();
          this.frmGroup.get(this.configData.name).updateValueAndValidity();
        }
      }
    }, this);
  }

  toggleDisable(disabled) {
    if (disabled === true) {
      this.frmGroup.get(this.configData.name).disable();
      this.formControl.nativeElement.parentElement.classList.add('disabled');
      this.disableSwitch = true;
    } else {
      this.frmGroup.get(this.configData.name).enable();
      this.formControl.nativeElement.parentElement.classList.remove('disabled');
      this.disableSwitch = false;
    }
  }

  popFieldAction(e) {
    this.fieldAction.emit(e);
  }

  onWindowClick(event) {
    if (!this._eref.nativeElement.contains(event.target)) {
        this.typing = event.target.id === 'apiCALL' ? true : false;
        let selection: any = this.frmGroup.get(this.configData.name).value;
        let dynamicDataAdded = this.frmGroup.get(this.configData.name)['dynamicDataAdded']
        let filterObj = this.alphaService.getFilteredObject("setFiltersValues");
        if (selection !== '' && !(this.isOpenManualAddSuggestion) && !dynamicDataAdded && this.configData.defaultValue["value"]?.length == 0 && !this.isResetting) {
          if (this.frmGroup.get(this.configData.name)['itemArray'] && this.frmGroup.get(this.configData.name)['itemArray'].indexOf(selection) < 0) {
            if(this.frmGroup.get(this.configData.name)['itemArray']?.length > 0)
              this.frmGroup.get(this.configData.name).setErrors({ 'selectFromList': true });
            else  
              this.frmGroup.get(this.configData.name).setErrors({ 'NoItemFound': true });
          }
        }
        if (filterObj && filterObj?.[this.configData.name] === this.frmGroup.get(this.configData.name).value) {
          this.frmGroup.get(this.configData.name).setErrors(null);
        }
    }
  }

  controlValueChange(e) {
    // this.controlValue.emit(e);
    console.log('change---->', e.target.value.trim())
    // this.frmGroup.get(this.configData.name).setValue(e.target.value.trim());
  }

  setOnFocus($event) {
    if (($event.target.value.trim().length >= 3) && this.suggestionList.length && !(this.isOpenManualAddSuggestion)) {
      this.typing = true;
    }
  }

  normalView() {
    throw new Error('Method not implemented.');
  }

  onkeyupHandler($event) {
    // if ($event.target.value.trim().length >= 3) {
    if (this.frmGroup.get(this.configData.name).value !== '') {
       if (this.suggestionList.length > 0 && this.selection === this.frmGroup.get(this.configData.name).value) {
        return;
      } else {
        this.selection = this.frmGroup.get(this.configData.name).value;
        this.frmGroup.get(this.configData.name).setErrors({ 'NoItemFound': true });
      }
    }

    this.frmGroup.get(this.configData.name)['secondaryText'] = '';
    this.noItemFound = false;
    let searchText = $event.currentTarget.value;
    if (searchText.length > this.configData['minSearchChar'] && searchText != null) {
      this.suggestionList = [];
      this.searchTerms.next(encodeURIComponent(searchText));
    } else {
      this.typing = false;
      this.suggestionList = [];
      this.frmGroup.get(this.configData.name)['itemArray'] = [];
    }
    if (this.configData.isSearchApi == true){
      if(searchText.length <= 0){
        let event: DhlFormControlEvent | null = this.checkEventExist(this.configData.events, 'SEARCHLOCATIONCLEAR');
        this.sendToSource({ searchText }, event);
      }
    }
  }

  storePreviousValue(){
    this.previousFormFieldData = this.frmGroup.get(this.configData.name).value;
  }
  ClearLocationSearch(searchText) { 
    this.searchStr = "";
    this.frmGroup.get(this.configData.name).setValue(this.searchStr);
    this.renderer.removeAttribute(this.inputEle.nativeElement, 'placeholder');
    this.renderer.removeClass(this.inputEle.nativeElement.parentElement, 'active');
    let event: DhlFormControlEvent | null = this.checkEventExist(this.configData.events, 'SEARCHLOCATIONCLEAR');
    this.sendToSource({searchText}, event);
  }

  selectItem($event, data, disabled, ignoreResetEvents = false) {
    //portalna 12519
    if (this.configData?.stopPropagation && this.configData?.stopPropagation === true){
      $event.stopPropagation();
    }
    //portalna 12519 end
    //send uom dropdown values to rateLookup screen.
    if(this.configData.volCalculation){
    let event: DhlFormControlEvent
    setTimeout(() => {
      this.sendVolumeDataToSource(event, this.frmGroup.value,data);
      })
    }
    //end

    this.noItemFound = false;
    this.suggestionList = [];
    if(this.autoCompleteMetaData.primaryText.length)
      this.frmGroup.get(this.configData.name).setValue(data.primaryValue);
    else
      this.frmGroup.get(this.configData.name).setValue(data);
    this.addNewSuggestion=false;
    let event = this.checkEventExist(this.autoCompleteMetaData.events, 'SET_VALUE');
    let autoCompleteValidateEvent: any = this.checkEventExist(this.autoCompleteMetaData.events, 'VALIDATE_WHEN_AUTOCOMPLETE_SELECTED');
    if(this.autoCompleteMetaData.events && event){
      this.sendToSource({data: data}, event);
    }
    if(this.autoCompleteMetaData.events && autoCompleteValidateEvent ){
      let eventsWithoutResetActions = null;
      if(ignoreResetEvents && autoCompleteValidateEvent && autoCompleteValidateEvent.props && Array.isArray( autoCompleteValidateEvent.props) && autoCompleteValidateEvent.props.length > 0){
        eventsWithoutResetActions = Object.assign({}, autoCompleteValidateEvent);
        eventsWithoutResetActions.props = eventsWithoutResetActions.props.filter(a => a.action !== "RESET");
      }
      this.sendToSource({data: data}, eventsWithoutResetActions || autoCompleteValidateEvent);
    }
    if (this.autoCompleteMetaData?.isSearchApi) {
      if (this.configData?.name === 'originRegionName') {
        localStorage.setItem('originRegion', JSON.stringify({ "originRegionvalue": data.primaryValue, "component": this.configData.name }));
      }
      else if (this.configData?.name === 'destRegionName') {
        localStorage.setItem('destRegion', JSON.stringify({ "destRegionvalue": data.primaryValue, "component": this.configData.name }));
      }
      let autocompleteRegion = this.checkEventExist(this.autoCompleteMetaData.events, 'SEARCHLOCATION');
      if (this.autoCompleteMetaData.events && autocompleteRegion) {
        let regionData = { "data": data, "comp": this.configData.name }
        this.sendToSource({ data: regionData }, autocompleteRegion);
      }
    }
    let autocompleteData = data.address ? data.address : data
    if (this.configData.isfromAddress){
      this.appService.setOriginUsedLocation(autocompleteData);
    } else if(this.configData.isToAddress){
      this.appService.setDestinationUsedLocation(autocompleteData);
    } 
    this.alphaService.manageAffectedColumn(this.configData, this.frmGroup, data, ignoreResetEvents);
    this.alphaService.setAffectedColumnValues(ignoreResetEvents);
  }
  AddNewSuggestion($e){
    this.isOpenManualAddSuggestion = true;
    let event: DhlFormControlEvent | null = this.checkEventExist(this.configData.events, 'ADD_NEW_SUGESSION');
    if (event) {
      this.sendToSource({data: ''},event);
    }
    this.addNewSuggestion=false;
  }
  checkEventExist(events, eventName): DhlFormControlEvent | null {
    let event = null;
    if (events && Array.isArray(events)) {
      event = events.filter(ele => ele.event == eventName);
      // Only applicablen to cox,Since it is aleary implemented at many place.
      if (event.length === 1) {
        event = event[0];
      } else if (event.length > 1) {
        event = event;
      } else { event = null }
    }
    return event;
  }
  sendToSource(sourceData, eventsValue ) {
    let events = eventsValue;
    if(sourceData.data){
      sourceData.data.previousFormFieldData = this.previousFormFieldData;
    }
    let eventData: DhlFormControlEventData = {
      event: events.event,
      eventData: ((!events.length || events.length === 1) ? events : events),
      action: ((!events.length || events.length === 1) ? events.event.toUpperCase() : 'MULTIPLE_ACTION'),
      name: this.configData.name,
      component: this,
      configData: this.configData,
      data: sourceData.data
    }

    let filterObj = this.alphaService.getFilteredObject("setFiltersValues");
    if (filterObj) {
      filterObj[this.configData.name] = this.frmGroup.get(this.configData.name).value;
      this.alphaService.setFilteredObject('setFiltersValues', filterObj);
    }
    this.appService._commonComponentSubject.next(eventData);
  }

  makeapicall(searchText) {
    this.progressBar = true;
    this.addNewSuggestion = false;
    if (this.configData['addNewSuggestion']) {
      this.addNewSuggestion = true;
    }
    this.typing = true;
    let url = this.controlUrlFlag ? this.configData['switchUrl'] :  this.configData['apiUrl'];
    if(this.autoCompleteMetaData['urlType'] === 'absolute' && this.autoCompleteMetaData['urlType'] && !this.controlUrlFlag){
      let node = document.createElement("div");
      node.id = 'apiCALL';
      this.onWindowClick({'target': node});
      url += searchText;
      if(this.autoCompleteMetaData['urlTokenName'] && this.autoCompleteMetaData['urlTokenValue'] && !this.controlUrlFlag){
        url += '&' + this.autoCompleteMetaData['urlTokenName'] + '=' + this.autoCompleteMetaData['urlTokenValue'] ;
      }
      if(this.autoCompleteMetaData['qparams'] && this.autoCompleteMetaData['qparams'].hasOwnProperty('addqparams')
      && this.autoCompleteMetaData['qparams']['addqparams'] && !this.controlUrlFlag){
        if(this.autoCompleteMetaData.qparams.hasOwnProperty('qparamlist') && Array.isArray(this.autoCompleteMetaData.qparams.qparamlist)
        && this.autoCompleteMetaData.qparams.qparamlist.length > 0){
          this.autoCompleteMetaData.qparams.qparamlist.forEach(qparam => {
            url += '&' + qparam['qkey'] + '=' + qparam['qval'];
          });
        }
      }
      url += '&userId=' + localStorage.getItem('userName');
      this.appService.makeHttpGetRequest(url).subscribe(response=>{
        this.cd.markForCheck();
        this.progressBar = false;
        if(response.hasOwnProperty(this.autoCompleteMetaData.responseListName) && response[this.autoCompleteMetaData.responseListName].length > 0){
          this.suggestionList = response[this.autoCompleteMetaData.responseListName];
          if(this.autoCompleteMetaData.primaryText.length){
            this.suggestionList = this.suggestionList.filter(function(suggestion){
              if(this.configData.hasOwnProperty('allowedResultTypes') && this.configData['allowedResultTypes'].length > 0){
                return this.configData['allowedResultTypes'].includes(suggestion.resultType);
              }else{
                return true;
              }
            }, this);
            this.suggestionList.map(suggestion=>{
              let primaryTextArr = [];
              this.autoCompleteMetaData.primaryText.forEach(primaryText => {
                primaryTextArr.push(suggestion[primaryText])
              });
              suggestion.primaryText = primaryTextArr.join(' - ');
              suggestion.primaryValue = primaryTextArr.join(' - ');
              this.frmGroup.get(this.configData.name)['itemArray'].push(primaryTextArr.join(' - '));
            })
          }
        } else {
          if (this.configData['addNewSuggestion']) {
            this.addNewSuggestion = true;
          }
          this.suggestionList = [];
          this.frmGroup.get(this.configData.name)['itemArray'] = [];
          this.noItemFound = true;
        }
      }, error=>{
        console.log(error);
        this.progressBar = false;
        let modal = new Modal({
          action: false, name: 'autocomplete', title: 'AutoComplete', description: error.message, actionButtonText: ''
        });
        this.modalService.createModalBox(modal, error.status);
      });
    } else {

      if(this.controlUrlFlag){
        url +=
        searchText.toUpperCase()
        + '&userId=' + localStorage.getItem('userName')
        + "&customerCode=" + localStorage.getItem('customerCode') + '&action=locationMaster';
      }
      else if(this.configData['withoutStaticParams']){
        if(this.configData['withCustomerIdParam']){
          url +=
          searchText.toUpperCase()
          + '&userId=' + localStorage.getItem('userName')
          + "&customerCode=" + localStorage.getItem('customerCode')+'&customerId=' + this.appService._components['customer'].frmGroup.get('customer').value;
        }else{
          url +=
          searchText.toUpperCase()
          + '&userId=' + localStorage.getItem('userName')
          + "&customerCode=" + localStorage.getItem('customerCode')
        }
      } else {
        url +=
        searchText.toUpperCase()
        + '&userId=' + localStorage.getItem('userName')
        + "&customerCode=" + localStorage.getItem('customerCode') + '&action=fetchClientDBA'
        + '&exclude=' + this.excludeItem;
      }
      url = this.appendAdditionalQueryParams(url);
    this.appService.makeHttpGetRequest(url)
      .subscribe(response => {
        this.cd.markForCheck();
        this.progressBar = false;
        if (response['message'].statusCode === APP_Constants.SUCCESS_CODE) {
          if(response['data']){
            if(this.controlUrlFlag){
              response['data']['businessObjects'].forEach(element => {
                element['houseNumber'] = element.address1;
                element['street'] = '';
                element['title'] = element.normalizedAddress;
              });
            }
            this.suggestionList = this.controlUrlFlag ? response['data']['businessObjects'] : response['data'][this.autoCompleteMetaData.responseListName];
          } else {
            this.suggestionList = response[this.autoCompleteMetaData.responseListName];
          }
          if(this.autoCompleteMetaData.primaryText.length){
            if(!this.controlUrlFlag){
              this.suggestionList = this.suggestionList.filter(function(suggestion){
                if(this.configData.hasOwnProperty('allowedResultTypes') && this.configData['allowedResultTypes'].length > 0){
                  return this.configData['allowedResultTypes'].includes(suggestion.resultType);
                }else{
                  return true;
                }
              }, this);
            }
            this.suggestionList.map(suggestion=>{
              let primaryTextArr = [];
              this.autoCompleteMetaData.primaryText.forEach(primaryText => {
                primaryTextArr.push(suggestion[primaryText])
              });
              suggestion.primaryText = primaryTextArr.join(' - ');
              suggestion.primaryValue = primaryTextArr.join(' - ');
              this.frmGroup.get(this.configData.name)['itemArray'].push(primaryTextArr.join(' - '));
          });
          } else {
            this.frmGroup.get(this.configData.name)['itemArray'] = this.suggestionList
          }

        } else {
          if (this.configData['addNewSuggestion']) {
            this.addNewSuggestion = true;
          }
          this.suggestionList = [];
          this.frmGroup.get(this.configData.name)['itemArray'] = [];
          this.frmGroup.get(this.configData.name).setErrors({ 'NoItemFound': true });
          this.noItemFound = true;
        }
      }, (err) => {
        this.progressBar = false;
        let modal = new Modal({
          action: false, name: 'autocomplete', title: 'AutoComplete', description: err.message, actionButtonText: ''
        });
        this.modalService.createModalBox(modal, err.status);
      });
    }
  }
  // NCP-13184 Binding Address 2  
  getMultipleAddress(suggestion: any): string {
    return `${suggestion.normalizedAddress || ''}<br><b>Address 2 :</b> ${suggestion.address2 || ''}`;
  }
  // NCP-13184 ends here
  appendAdditionalQueryParams(url: string) {
    if (this.autoCompleteMetaData['qparams'] &&
      this.autoCompleteMetaData.qparams.hasOwnProperty('addqparams') &&
      this.autoCompleteMetaData.qparams.addqparams &&
      this.autoCompleteMetaData.qparams.hasOwnProperty('qparamlist') &&
      Array.isArray(this.autoCompleteMetaData.qparams.qparamlist) &&
      this.autoCompleteMetaData.qparams.qparamlist.length > 0) {
      this.autoCompleteMetaData.qparams.qparamlist.forEach(qparam => {
        let qValu = qparam['qval'];
        if(
          qparam.hasOwnProperty('qType') && 
          qparam.qType === "form" && 
          this.appService._components[qparam['qval']] && 
          this.appService._components[qparam['qval']].frmGroup && 
          this.appService._components[qparam['qval']].frmGroup.get(qparam['qval']) && 
          this.appService._components[qparam['qval']].frmGroup.get(qparam['qval']).value){
            qValu = this.appService._components[qparam['qval']].frmGroup.get(qparam['qval']).value;
        }
        url += '&' + qparam['qkey'] + '=' + qValu;
      });
    }
    return url;
  }

  close() {
    this.searchStr = "";
    this.frmGroup.get(this.configData.name).setValue(this.searchStr);
    this.typing = false;
    this.renderer.removeAttribute(this.inputEle.nativeElement, 'placeholder');
    this.renderer.removeClass(this.inputEle.nativeElement.parentElement, 'active');
  }

  setValueToControl(value){
    if (value != undefined) {
      this.frmGroup.get(this.configData.name).setValue(value);
      this.frmGroup.get(this.configData.name)["itemArray"].push(value);
    }
  }

  resetAutocompleteFieldValue() {
    this.controlUrlFlag = false;
  }
  
  sendVolumeDataToSource(event: DhlFormControlEvent, data: any, dimentionValue:any) {
    let eventData: DhlFormControlEventData = {
      action: 'VOLUME_CALCULATION',
      name: this.configData.name,
      component: this,
      configData: this.configData,
      data: data,
      event: 'CREATE_ORDER',
      eventData: dimentionValue
    }
    this.appService._commonComponentSubject.next(eventData);
  }

  toggleUrl(event){
    if (this.configData?.['eventBasedSwitch']) {
      this.controlUrlFlag = event;
    } else {
      this.controlUrlFlag = event?.target?.checked;
      this.frmGroup.get(this.configData.name).setValue(null);
      this.suggestionList = [];
      this.frmGroup.get(this.configData.name)['itemArray'] = [];
    }
  }

  ngOnDestroy() {
    if (this.clickEventSubscription) {
      this.clickEventSubscription.unsubscribe();
    }
    if (this.keyUpEventSubscription) {
      this.keyUpEventSubscription.unsubscribe();
    }
    if (this.keyUpTabEventSubscription) {
      this.keyUpTabEventSubscription.unsubscribe();
    }
    if(this.controlStateSubscription){
      this.controlStateSubscription.unsubscribe();
    }
  }
}
